import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ExperimentStatus } from "@/types/enums";
import { EXPERIMENT_STATUS_LABELS } from "./experiment-status-badge";

const ALL_VALUE = "all";

const STATUS_OPTIONS = [
  { value: ALL_VALUE, label: "전체" },
  ...Object.entries(EXPERIMENT_STATUS_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
];

interface ExperimentFiltersProps {
  status: ExperimentStatus | undefined;
  onStatusChange: (status: ExperimentStatus | undefined) => void;
}

export function ExperimentFilters({
  status,
  onStatusChange,
}: ExperimentFiltersProps) {
  return (
    <div className="flex items-center gap-3">
      <Select
        value={status || ALL_VALUE}
        onValueChange={(val) =>
          onStatusChange(val === ALL_VALUE ? undefined : (val as ExperimentStatus))
        }
      >
        <SelectTrigger className="w-[140px]">
          <SelectValue placeholder="상태 필터" />
        </SelectTrigger>
        <SelectContent>
          {STATUS_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
